// extracted by mini-css-extract-plugin
module.exports = {"clubTerms":"ClubTerms_clubTerms__cEBOw","termsModalButtons":"ClubTerms_termsModalButtons__6T74L","termsCheckbox":"ClubTerms_termsCheckbox__vTVh8"};